import styled, { css } from 'styled-components'

export const CardInputMessageWrapper = styled.div`
  font-family: 'Roboto', sans-serif !important;
  position: relative;
  flex: 3;
  display: flex;
  flex-direction: column;
  height: 510px;
  margin-top: 0;
  margin-bottom: auto;
`

export const CardInputMessageContent = styled.div<{
  isTextArea: boolean
  isError: boolean
}>`
  ${({ theme, isTextArea, isError }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
    padding: ${isTextArea ? 0 : '24px 32px'};
    overflow-y: auto;
    flex: 1;
    height: 100%;
    border: 2px solid
      ${isError ? theme.ds.colors.danger300 : theme.ds.colors.neutral200};
    border-radius: 8px;

    ${isTextArea &&
    css`
      textarea {
        flex: 1;
        width: 100%;
        height: 100%;
        resize: none;
        border: none;
        box-sizing: border-box;
        border-radius: 8px;
      }
    `}
  `}
`
